import { render } from "./IMIVVitaminTherapiesContentPtBR.vue?vue&type=template&id=042f794a&scoped=true"
import script from "./IMIVVitaminTherapiesContentPtBR.vue?vue&type=script&lang=js"
export * from "./IMIVVitaminTherapiesContentPtBR.vue?vue&type=script&lang=js"

import "./IMIVVitaminTherapiesContentPtBR.vue?vue&type=style&index=0&id=042f794a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042f794a"]])

export default __exports__